import { generateUtilityClasses as muiGenerateUtilityClasses } from '@mui/material';

export const generateUtilityClasses = muiGenerateUtilityClasses;
